import { FC, useCallback, useEffect } from 'react';
import settings from './settings';

const CONTAINER_ID = 'CLAIMR_CONTAINER';
const SCRIPT_ID = 'claimr-script';

export const ClaimrWidgetComponent: FC = () => {
    const handle_script_creation = useCallback(() => {
        let script = document.getElementById(SCRIPT_ID);

        if (!script) {
            script = document.createElement('script');

            script.setAttribute('id', SCRIPT_ID);
            script.setAttribute('data-container', CONTAINER_ID);
            script.setAttribute('src', settings.claimr_lib_url);
            script.setAttribute('data-organization', settings.organization_tag);
            script.setAttribute('data-campaign', settings.campaign_tag);
            script.setAttribute('data-addons', 'sup,eap,pvm,dcc');
            script.setAttribute('data-autoresize', 'true');
            script.setAttribute('data-platform', 'telegram');

            document.body.appendChild(script);
        }
    }, []);

    useEffect(() => {
        handle_script_creation();
    }, [handle_script_creation]);

    return (
        <div className='claimr-container'>
            <div id={CONTAINER_ID} />
        </div>
    );
};
